const routes = {
    home: '/',
    login: '/login',
    forgotPassword: '/forgot-password',
    admin: {
        base: '/admin',

        concert: '/concert',
        concertFull: '/admin/concert',

        lyrics: '/lyrics',
        lyricsFull: '/admin/lyrics',

        lyricsListItems: '/lyrics/items',
        lyricsListItemsFull: '/admin/lyrics/items',


        discographyAlbums: '/discography/albums',
        discographyItems: '/discography/items',
        discographyFullFull: '/admin/discography',
        discographyAlbumsFull: '/admin/discography/albums',
        discographyItemsFull: '/admin/discography/items',

        lyricsCategories: '/lyrics/category',
        lyricsCategoriesFull: '/admin/lyrics/category',

        user: '/user',
        userFull: '/admin/user',

        generalSettings: '/general-settings',
        generalSettingsFull: '/admin/general-settings',

        blog: '/blog',
        blogFull: '/admin/blog',
    }
};

export default routes;
